import {
  Button,
  ButtonProps,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AccountCircleOutlined } from '@mui/icons-material';
import { MouseEventHandler } from 'react';
import { IIdentityContext } from '@almamedia-legal-insights/types';

export default function AccountMenuButton({
  identityContext,
  open,
  onClick,
}: Readonly<{
  identityContext: IIdentityContext;
  open: boolean;
  onClick: MouseEventHandler;
}>) {
  const theme = useTheme();
  const { t } = useTranslation();
  const minifyButton = useMediaQuery(theme.breakpoints.down('md'));
  const toggleButtonProps: ButtonProps = {
    id: 'account-menu-button',
    'aria-controls': 'account-menu',
    'aria-haspopup': 'menu',
    'aria-expanded': open,
    onClick,
  };

  const { authInfo, user } = identityContext;
  const isAuthenticated = Boolean(authInfo?.ipAuth || user);
  const label = isAuthenticated
    ? t('accountMenu.account')
    : t('accountMenu.loginPrompt');

  return minifyButton ? (
    <Tooltip title={label}>
      <IconButton
        color='primary'
        size='large'
        aria-label={label}
        sx={{ color: 'text.secondary' }}
        {...toggleButtonProps}
      >
        <AccountCircleOutlined />
      </IconButton>
    </Tooltip>
  ) : (
    <Button
      endIcon={<AccountCircleOutlined />}
      variant='text'
      size='small'
      sx={{
        color: 'text.primary',
        fontSize: '14px',
        textTransform: 'none',
      }}
      disableElevation
      {...toggleButtonProps}
    >
      {label}
    </Button>
  );
}
